import NoticeServices from "@/services/NoticeServices";

const types = {
  GET_NOTICES: '@NOTICES/GET_NOTICES'
  ,GET_NOTICE: '@NOTICES/GET_NOTICE'
  ,GET_SELECT_NOTICE: '@NOTICES/GET_SELECT_NOTICE'
}

export {
  types as noticesTypes
}

export default {
  namespaced: true,
  state: {
    notices: [],
    notice: {},
    selectNotice: {}
  },

  getters: {
    notices: (state) => {
      return state.notices
    },
    notice: (state) => {
      return state.notice
    },
    selectNotice: (state) => {
      return state.selectNotice
    },
  },

  mutations: {
    [types.GET_NOTICES] (state, payload) {
      state.notices = payload.notices
    },
    [types.GET_NOTICE] (state, payload) {
      state.notice = payload.notice
    },
    [types.GET_SELECT_NOTICE] (state, payload) {
      state.selectNotice = payload.selectNotice
    }
  },

  actions: {
    async getNotices ({ commit }, payload) {
      commit(types.GET_NOTICES, { notices: [] })
      const { category, pageNo, size, searchText} = payload
      const response = await NoticeServices.getNotices({
        category, pageNo, size, searchText
      })
      commit(types.GET_NOTICES, { notices: response.data.resultData.notice })
      return response.data.resultData
    },
    async getNotice ({ commit }, id) {
      commit(types.GET_NOTICE, { notice: {} })
      const response = await NoticeServices.getNoticeWithId(id)
      commit(types.GET_NOTICE, { notice: response.data.resultData })
      return response.data.resultData
    },
    async setSelectNotice ({commit}, payload) {
      const selectNotice = payload.selectNotice
      commit(types.GET_SELECT_NOTICE, {selectNotice})
      return selectNotice
    },
    async insertNotices ({ commit }, payload) {
      const {content, fileId, tenantCode, title} = payload
      const response = await NoticeServices.insertNotices(
        {content, fileId, tenantCode, title}
      )
      return response.data.resultData
    },
    async updateVisible ({ commit }, id) {
      const response = await NoticeServices.updateVisible(id)
      return response.data.resultData
    },
    async deleteNotice ({ commit }, id) {
      const response = await NoticeServices.deleteNoticeWithId(id)
      return response.data.resultData
    },
    async putNoticeWithId ({ commit }, payload) {
      const {content, fileId, tenantCode, title, visible} = payload
      const response = await NoticeServices.putNoticeWithId(payload.id, {
        content, fileId, tenantCode, title, visible
      })
      return response.data.resultData
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/notice.js